import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const teamMembers = [
  {
    name: 'Gerson Ortiz Odatte',
    role: 'CEO',
    description: 'Dirección General Estratégica',
    image: 'https://customer-assets.emergentagent.com/job_orian-creative/artifacts/h4pkly5x_IMG_20260226_233119_208.webp',
  },
  {
    name: 'Roberto Esteban Puello',
    role: 'Director de Producción',
    description: 'Director de Producción General',
    image: 'https://customer-assets.emergentagent.com/job_orian-creative/artifacts/tfyeoka2_file_00000000bf2c71f5b7e0e8fa83b74ef1.png',
  },
  {
    name: 'Jeffrey Charles',
    role: 'Supervisor de Servicios',
    description: 'Supervisor de Servicios General',
    image: 'https://customer-assets.emergentagent.com/job_orian-creative/artifacts/dxhxq1za_file_00000000f1a071f5b33c492539b0cb6e.png',
  },
  {
    name: 'Yandel Valdez Chevalier',
    role: 'Director Creativo',
    description: 'Dirección Creativa de Contenido',
    image: 'https://customer-assets.emergentagent.com/job_orian-creative/artifacts/l27ghof3_file_00000000059c71f58c9bb082f6542f14.png',
  },
];

export default function Team() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="team"
      ref={ref}
      className="relative py-24 md:py-32 bg-[#0a0a0a]"
      data-testid="team-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <span className="text-xs font-mono tracking-[0.3em] uppercase text-[#D4AF37] mb-4 block">
            Our Team
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white">
            Quienes Hacemos
            <br />
            <span className="gold-text">Posible Tu Visión</span>
          </h2>
        </motion.div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 + index * 0.15 }}
              className="group"
              data-testid={`team-member-${index}`}
            >
              {/* Image Container */}
              <div className="relative overflow-hidden mb-6 aspect-[3/4]">
                <motion.img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.6 }}
                />
                {/* Gold overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" />
                
                {/* Border animation */}
                <motion.div
                  className="absolute inset-0 border-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </div>

              {/* Info */}
              <div className="text-center">
                <span className="text-xs font-mono tracking-[0.2em] uppercase text-[#D4AF37] mb-2 block">
                  {member.role}
                </span>
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 group-hover:text-[#D4AF37] transition-colors duration-300">
                  {member.name}
                </h3>
                <p className="text-sm text-zinc-500">
                  {member.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
